import { render, staticRenderFns } from "./main-section.vue?vue&type=template&id=44f8d03c&scoped=true"
import script from "./main-section.vue?vue&type=script&lang=js"
export * from "./main-section.vue?vue&type=script&lang=js"
import style0 from "./main-section.vue?vue&type=style&index=0&id=44f8d03c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f8d03c",
  null
  
)

export default component.exports